import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from '../../environments/environment';
import {firstValueFrom} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class BaseApiService {
  readonly httpOptions: any = {
    withCredentials: true
  }
  readonly apiRoute = environment.baseUrl;
  private readonly http = inject(HttpClient);

  async get(url: string) {
    return await firstValueFrom(this.http.get<any>(`${this.apiRoute}${url}`, this.httpOptions));
  }

  async post(url: string, body: any) {
    return await firstValueFrom(this.http.post<any>(`${this.apiRoute}${url}`, body, this.httpOptions)).catch(() => {
      return {isSuccess: false};
    });
  }

  postObservable(url: string, body: any) {
    return this.http.post<any>(`${this.apiRoute}${url}`, body, this.httpOptions);
  }

  async put(url: string, body: any) {
    return await firstValueFrom(this.http.put<any>(`${this.apiRoute}${url}`, body, this.httpOptions)).catch(() => {
      return {isSuccess: false};
    });
  }

  async patch(url: string, body: any) {
    return await firstValueFrom(this.http.patch<any>(`${this.apiRoute}${url}`, body, this.httpOptions)).catch(() => {
      return {isSuccess: false};
    });
  }

  async delete(url: string, body: any) {
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      withCredentials: true,
      body: body,
    };
    return await firstValueFrom(this.http.delete<any>(`${this.apiRoute}${url}`, options)).catch(() => {
      return {isSuccess: false};
    });
  }
}
